import { Selector } from "@ngxs/store";
import { CoreStateModel } from "./core.model";
import { CoreState } from "./core.state";

export class CoreSelectors {

    private static getInstanceState(state: CoreStateModel): CoreStateModel {
        return { ...state };
      }

    @Selector([CoreState])
    static getCoreData(state: CoreStateModel): CoreStateModel {
      return CoreSelectors.getInstanceState(state);
    }

    @Selector([CoreState])
    static getAppConnectedSessions(state: CoreStateModel): number {
        return state.appConnectedSessions.length;
    }
}